import React from 'react';
import About from './About';

const AboutPage = () => {
  return (
    <div className="pt-24">
      <About />
    </div>
  );
};

export default AboutPage;